<template>
  <table>
    <thead>
      <th v-bind:key="index" v-for="(header, index) in headers">{{header.name}}</th>
    </thead>
    <tbody>
      <tr v-bind:key="rowIndex" v-for="(row, rowIndex) in rows">
        <td v-for="(header, headerIndex) in headers" :key="headerIndex">{{row[header.value]}}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "home",
  props: ["headers", "rows"],
  components: {}
};
</script>
